import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const traccarConfig: TSPConfig = {
  key: 'traccar',
  name: 'Traccar',
  category: TSPCategory.API_KEY,
  helpText:
    'Input the credentials you use to log into the Traccar Dashboard and request an API Key from your Traccar representative.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
      ]}
    />
  ),
};

export default traccarConfig;
